import {useQuery} from '@tanstack/react-query';
import {
  getBackgroundTasks,
  getBackgroundTaskStatuses,
} from '../../api/endpoints/backgroundTasksAPI';

export const useBackgroundTasks = (payload: any) => {
  return useQuery<any, Error>({
    queryKey: ['backgroundTask', payload],
    queryFn: () => getBackgroundTasks(payload),
    retry: 2,
  });
};

export const useBackgroundTaskStatuses = () => {
  return useQuery<any, Error>({
    queryKey: ['backgroundTaskStatus'],
    queryFn: () => getBackgroundTaskStatuses(),
    retry: 2,
  });
};
